export function getProfile(profils, functionnalities) {
	let profile;
	if(profils != null){
		if (profils.find((profil) => profil?.code == 'admin') || 
		profils.find((profil) => profil?.code == 'mgt') ) {
			profile = {
				extrawork: true,
				validateQuote: true,
				rejectQuote: true,
			};
		} else if(profils.find((profil) => profil?.code == 'com')){
			profile = {
				extrawork: true,
				validateQuote: false,
				rejectQuote: false,
			};
		}
		else if(profils.find((profil) => profil?.code == 'oper')){
				profile = {
					extrawork: false,
					validateQuote: false,
					rejectQuote: false,
				};
		}
	}

	if(functionnalities.includes("all")){
		profile = {
			extrawork: true,
			validateQuote: true,
			rejectQuote: true,
		};
	}
	return profile;
}